class Navigation extends HTMLElement {
  constructor() {
    super();

    this.checkScrollDirection.bind(this);

    this.isActiveClass = "is-active";
    this.isVisibleClass = "is-visible";
    this.isActiveSubMenu = "is-active-sub-menu";

    this.screen_size = window.innerWidth;
    this.menu = this.querySelector("#menu_btn");
    this.menu_block = this.querySelectorAll(".menu_block");
    this.menu_content = this.querySelector("#menu_content");
    this.parent_link = this.querySelectorAll(".parent_link");
    this.closeToggles = this.querySelectorAll(".close-menu");
    this.menu_nav_text = this.querySelector("#menu_nav_text");
    this.subMenuWrapper = this.querySelector(".level_2_menu");
    this.subMenu = document.querySelector(".mobile_header_menu");
    this.child_link = document.querySelectorAll(".child_link");
    this.children_link = this.querySelectorAll(".children_link");
    this.menu_background = this.querySelector("#menu-background");
    this.announcementBar = this.querySelector(".announcement-bar");
    this.backOneLevelButton = document.querySelectorAll(".back-one-level");

    this.closeToggles.forEach((toggle) => {
      toggle.addEventListener("click", this.open.bind(this));
    });
    this.menu.addEventListener("click", this.open.bind(this));

    this.init();
    this.initCarousel();
  }

  init() {
    document.body.addEventListener("wheel", this.checkScrollDirection);
    const {
      menu_block,
      menu_content,
      menu_background,
      child_link,
      children_link,
      screen_size,
      parent_link,
      isActiveClass,
      isVisibleClass,
      isActiveSubMenu,
      subMenu,
      subMenuWrapper,
      backOneLevelButton,
    } = this;

    if (this.screen_size > 990) {
      for (let i = 0; i < menu_block.length; i++) {
        const firstMenu = menu_block[0];
        const firstParentMenu = firstMenu.firstElementChild;
        const firstChildMenu = firstParentMenu.nextElementSibling;

        window.addEventListener("load", () => {
          firstParentMenu && firstParentMenu.classList.add("default");
          firstChildMenu && firstChildMenu.classList.add("default");
        });

        menu_block[i].addEventListener("mouseenter", function () {
          document.body.classList.add("scrolled_down");
          document.body.classList.remove("scrolled_up");
          this.classList.add("active");
          const parent_menu = this.firstElementChild;
          const parentMenuId = parent_menu.id;
          const child_menu = parent_menu.nextElementSibling;

          for (let j = 0; j < menu_block.length; j++) {
            const count = j + 1;
            const currentBlock = "parent_block-" + count;
            if (parentMenuId != currentBlock) {
              const otherBlock = menu_block[j].firstElementChild;
              otherBlock.classList.add("inactive");
            }
          }

          const child_menu_first = document.querySelector(
            ".center_nav #child_block-2 > .children_menu"
          );
          const childMenus = document.querySelectorAll(
            ".center_nav #child_block-2 .children_menu"
          );
          const navTitles = document.querySelectorAll(
            ".center_nav .nav_titles.hide-mobile span"
          );

          if (child_menu_first) {
            child_menu_first.classList.add("active");
            navTitles[0].classList.add("active");
          }

          navTitles.forEach((title, index) => {
            title.addEventListener("mouseenter", function () {
              navTitles.forEach((navTitle) =>
                navTitle.classList.remove("active")
              );
              childMenus.forEach((menu) => menu.classList.remove("active"));
              this.classList.add("active");

              if (childMenus[index]) {
                childMenus[index].classList.add("active");
              }
            });
          });

          parent_menu.classList.add("active");
          if (child_menu) {
            child_menu.classList.add("active");
          }

          firstParentMenu && firstParentMenu.classList.remove("default");
          firstChildMenu && firstChildMenu.classList.remove("default");
        });

        menu_block[i].addEventListener("mouseleave", function () {
          this.classList.remove("active");
          const parent_menu = this.firstElementChild;
          const parentMenuId = parent_menu.id;
          const child_menu = parent_menu.nextElementSibling;

          for (let j = 0; j < menu_block.length; j++) {
            const count = j + 1;
            const currentBlock = "parent_block-" + count;

            if (parentMenuId != currentBlock) {
              const otherBlock = menu_block[j].firstElementChild;
              otherBlock.classList.remove("inactive");
            }
          }

          const childMenus = document.querySelectorAll(
            ".center_nav #child_block-2 .children_menu"
          );
          const navTitles = document.querySelectorAll(
            ".center_nav .nav_titles.hide-mobile span"
          );
          navTitles.forEach((navTitle) => navTitle.classList.remove("active"));
          childMenus.forEach((menu) => menu.classList.remove("active"));

          parent_menu.classList.remove("active");
          if (child_menu) {
            child_menu.classList.remove("active");
          }

          firstParentMenu && firstParentMenu.classList.add("default");
          firstChildMenu && firstChildMenu.classList.add("default");
        });
      }
      for (let j = 0; j < child_link.length; j++) {
        child_link[j].addEventListener("mouseenter", function () {
          this.classList.add("active");
          const link = this.firstElementChild;
          const link_text = link.innerText
            .toLowerCase()
            .trim()
            .split(" ")
            .join("");
          menu_background &&
            menu_background.classList.add("header_bg-" + link_text);
          child_link[j].classList.add("in-active");
        });
        child_link[j].addEventListener("mouseleave", function () {
          this.classList.remove("active");
          const link = this.firstElementChild;
          const link_text = link.innerText
            .toLowerCase()
            .trim()
            .split(" ")
            .join("");
          menu_background &&
            menu_background.classList.remove("header_bg-" + link_text);
        });
      }
      for (let j = 0; j < children_link.length; j++) {
        children_link[j].addEventListener("mouseenter", function () {
          this.classList.add("active");
          const link = this.firstElementChild;
          const link_text = link.innerText
            .toLowerCase()
            .trim()
            .split(" ")
            .join("");
          menu_background &&
            menu_background.classList.add("header_bg-" + link_text);
        });
        children_link[j].addEventListener("mouseleave", function () {
          this.classList.remove("active");
          const link = this.firstElementChild;
          const link_text = link.innerText
            .toLowerCase()
            .trim()
            .split(" ")
            .join("");
          menu_background &&
            menu_background.classList.remove("header_bg-" + link_text);
        });
      }
    } else if (screen_size < 991) {
      var scrollPos = 0;

      window.addEventListener("scroll", function () {
        var currentScrollPos = document.body.getBoundingClientRect().top;

        if (currentScrollPos >= scrollPos || currentScrollPos > -5) {
          document.body.classList.remove("scrolled_down");
          document.body.classList.add("scrolled_up");
        } else {
          document.body.classList.add("scrolled_down");
          document.body.classList.remove("scrolled_up");
        }
        scrollPos = currentScrollPos;
      });

      function triggerAfterMobileMenuAdded() {
        const child_menu_first_mobile = document.querySelector(
          ".mobile_header_menu #child_block-2 > .children_menu"
        );
        const childMenusMobile = document.querySelectorAll(
          ".mobile_header_menu #child_block-2 .children_menu"
        );
        const navTitlesMobile = document.querySelectorAll(
          ".mobile_header_menu .nav_titles.hide-desktop span"
        );

        if (child_menu_first_mobile) {
          child_menu_first_mobile.classList.add("active");
          navTitlesMobile[0].classList.add("active");
        }

        navTitlesMobile.forEach((title, index) => {
          title.addEventListener("click", function () {
            navTitlesMobile.forEach((navTitle) =>
              navTitle.classList.remove("active")
            );
            childMenusMobile.forEach((menu) => menu.classList.remove("active"));
            this.classList.add("active");

            if (childMenusMobile[index]) {
              childMenusMobile[index].classList.add("active");
            }
          });
        });

        const childrenMenuSlider = document.querySelector(
          ".mobile_header_menu .children_menu_slider"
        );

        if (childrenMenuSlider) {
          new Swiper(childrenMenuSlider, {
            // freeMode: true,
            // setWrapperSize: true,
            // watchSlidesVisibility: true,
            // watchSlidesProgress: true,
            // slideToClickedSlide: true,
            // centeredSlides: true,
            // centeredSlidesBounds: true,
            // cardsEffect: {
            //   rotate: false,
            //   slideShadows: false,
            // },
            // autoplay: false,
            // speed: 200,
            direction: 'horizontal',
            height: 400,
            width: 400,
            slidesPerView: 2,
            grid: {
              fill: "column",
              rows: 2,
            },
            allowTouchMove: true,
            spaceBetween: 0,
            rewind: false,
            loop: false,
            cssMode: true,
            touchStartPreventDefault: false,
            passiveListeners: true,
            touchAngle: 45,
            pagination: {
              el: ".children_menu_slider-pagination",
              clickable: true,
            },
          });
        }
      }

      for (let i = 0; i < parent_link.length; i++) {
        parent_link[i].addEventListener("click", function (e) {
          const siblingList = this.nextElementSibling;

          if (siblingList.nodeName == "UL") {
            if (siblingList) {
              e.preventDefault();
              this.classList.add(isActiveClass);
              const cloneSiblingList = siblingList.cloneNode(true);

              subMenuWrapper.innerHTML = "";
              subMenuWrapper.append(cloneSiblingList);
              menu_content.classList.add(isActiveSubMenu);
              document.querySelector("body").classList.add(isActiveSubMenu);
              subMenu.classList.add(isVisibleClass);
              triggerAfterMobileMenuAdded();
            }
          }
        });
      }

      for (const backOneLevelBtn of backOneLevelButton) {
        backOneLevelBtn.addEventListener("click", function () {
          const parent = this.closest(".mobile_header_menu ");
          parent.classList.remove(isVisibleClass);
          parent.previousElementSibling
            .querySelector(".is-active")
            .classList.remove(isActiveClass);
          menu_content.classList.remove(isActiveSubMenu);
          document.querySelector("body").classList.remove(isActiveSubMenu);
        });
      }
    }
  }

  open() {
    document.body.classList.toggle("menu-open");
    this.menu.classList.toggle("active");
    this.menu_content.classList.toggle("open");

    if (this.menu_nav_text.innerHTML === "MENU") {
      this.menu_nav_text.innerHTML = "CLOSE";
    } else {
      this.menu_nav_text.innerHTML = "MENU";
    }
  }

  checkScrollDirection(event) {
    function checkScrollDirectionIsUp() {
      if (event.wheelDelta) {
        return event.wheelDelta > 0 || window.scrollY === 0;
      }
      return event.deltaY < 0 || window.scrollY === 0;
    }

    if (window.scrollY <= 5) {
      document.body.classList.remove("scrolled_down");
      document.body.classList.add("scrolled_up");
    } else {
      document.body.classList.add("scrolled_down");
      document.body.classList.remove("scrolled_up");
    }
  }

  initCarousel() {
    const childrenMenuSliderDesktop = document.querySelector(
      ".center_nav.header_menu .children_menu_slider"
    );

    if (childrenMenuSliderDesktop) {
      new Swiper(childrenMenuSliderDesktop, {
        // freeMode: true,
        // watchSlidesVisibility: true,
        // watchSlidesProgress: true,
        // slideToClickedSlide: true,
        // setWrapperSize: true,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        // cardsEffect: {
        //   rotate: false,
        //   slideShadows: false,
        // },
        // autoplay: false,
        // speed: 200,
        slidesPerGroup: 4,
        slidesPerView: 4,
        allowTouchMove: false,
        spaceBetween: 0,
        rewind: false,
        loop: false,
        cssMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }

    // document.querySelectorAll(".children_menu_slider").forEach((carousel) => {
    //   const items = carousel.querySelectorAll(".children_slider");
    //   const prevBtn = document.createElement("button");
    //   const nextBtn = document.createElement("button");

    //   let currentIndex = 0;
    //   const maxIndex = Math.ceil(items.length / 4) - 1;

    //   prevBtn.className = "nav-arrow left";
    //   prevBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
    //     <polyline points="15 18 9 12 15 6"></polyline>
    //   </svg>`;
    //   prevBtn.style.display = "none";

    //   nextBtn.className = "nav-arrow right";
    //   nextBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
    //     <polyline points="9 18 15 12 9 6"></polyline>
    //   </svg>`;

    //   carousel.appendChild(prevBtn);
    //   carousel.appendChild(nextBtn);

    //   function updateCarousel() {
    //     items.forEach((item, index) => {
    //       item.style.transform = `translateX(-${
    //         currentIndex === 0
    //           ? currentIndex * 57.6666666668
    //           : currentIndex * 58.3333333333
    //       }vw)`;
    //     });
    //     prevBtn.style.display = currentIndex === 0 ? "none" : "block";
    //     nextBtn.style.display = currentIndex === maxIndex ? "none" : "block";
    //   }

    //   prevBtn.addEventListener("click", () => {
    //     if (currentIndex > 0) {
    //       currentIndex--;
    //       updateCarousel();
    //     }
    //   });

    //   nextBtn.addEventListener("click", () => {
    //     if (currentIndex < maxIndex) {
    //       currentIndex++;
    //       updateCarousel();
    //     }
    //   });

    //   updateCarousel();
    // });
  }
}

customElements.define("custom-header", Navigation);

class NotificationBar extends HTMLElement {
  constructor() {
    super();

    this.init.bind(this);
    this.close.bind(this);
    this.setLocal.bind(this);
    this.getLocal.bind(this);

    this.screen_size = window.innerWidth;
    this.showNotification = this.getLocal();
    this.closeButton = this.querySelector(".announcement-bar__close-btn");

    if (!this.closeButton) {
      document.body.classList.add("hide-notification");
      return;
    }

    this.closeButton.addEventListener("click", this.close.bind(this));

    this.init();
  }

  init() {
    this.showNotification === "false" ? this.close() : this.show();
  }

  close() {
    this.style.display = "none";
    document.body.classList.add("hide-notification");
    this.setLocal();
  }

  show() {
    this.style.display = "block";
    document.body.classList.remove("hide-notification");
  }

  setLocal() {
    localStorage.setItem("showNotification", "false");
  }

  getLocal() {
    const isSet = localStorage.getItem("showNotification");
    return isSet ? localStorage.getItem("showNotification") : "true";
  }
}

customElements.define("notification-bar", NotificationBar);
